import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserMenuComponent } from './user-menu.component';
import {MaterialModule} from '../../material.module';
import {InfraModule} from 'ac-infra';



@NgModule({
    declarations: [UserMenuComponent],
    exports: [
        UserMenuComponent
    ],
  imports: [
    CommonModule,
    MaterialModule,
    InfraModule
  ]
})
export class UserMenuModule { }
